import _ from 'lodash'
import cn from 'classnames'
import React from 'react'
import { subYears } from 'date-fns'
import Flatpickr from 'react-flatpickr'

import lang from 'lang'

interface OfflineTrainingType {
  id: string
  name: string
}

interface Props {
  index: number
  errors?: { offline_training_id?: string; training_attended_at?: string }
  onRemoveTrainingHandler: () => void
  onTrainingChangeHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void
  onDateChangeHandler: (date: Date) => void
  offline_training_id?: string | null
  training_attended_at?: string | null
  usedTrainingTypes?: string[]
  offlineTrainingTypes: OfflineTrainingType[]
}

export default class TrainingRecord extends React.Component<Props> {
  render(): React.ReactNode {
    const err = this.props.errors ?? {}
    return (
      <React.Fragment key={this.props.index}>
        <div className="cell medium-3 small-6">
          <label className="text-right " htmlFor="training_attended_at">
            <select
              name="offline_training_id"
              id="offline_training_id"
              onChange={this.props.onTrainingChangeHandler}
              value={this.props.offline_training_id ?? ''}>
              <option value="">Select Training</option>
              {_.map(this.props.offlineTrainingTypes, (item) => (
                <option
                  value={item.id}
                  key={item.id}
                  disabled={_.includes(this.props.usedTrainingTypes, item.id)}>
                  {item.name}
                </option>
              ))}
            </select>
          </label>
          <span className={cn('form-error', { 'is-visible': err.offline_training_id })}>
            {err.offline_training_id}
          </span>
        </div>
        <div className="cell medium-4 small-6">
          <Flatpickr
            value={this.props.training_attended_at ?? ''}
            placeholder={lang.page.moodMeter.selectDate}
            options={{
              dateFormat: 'Y-m-d',
              minDate: subYears(new Date(), 5),
            }}
            onChange={(date: Date[]) => {
              if (date[0]) this.props.onDateChangeHandler(date[0])
            }}
          />
          <span className={cn('form-error', { 'is-visible': err.training_attended_at })}>
            {err.training_attended_at}
          </span>
        </div>
        <div className="cell medium-5">
          <button
            type="button"
            className="button hollow small"
            onClick={this.props.onRemoveTrainingHandler}>
            {lang.remove}
          </button>
        </div>
      </React.Fragment>
    )
  }
}
